import type { FC } from "react";
import type { SessionDetailsResponse } from "../../interfaces/sessionDetails";
import { useLocalization } from "../../stores/localizationContext";
import "./SessionDetailsHeader.scss";

type SessionDetailsHeaderProps = {
  details: SessionDetailsResponse;
};

const ICON_PLACEHOLDER = "ICON_CDN_NOT_SET";

export const SessionDetailsHeader: FC<SessionDetailsHeaderProps> = ({
  details,
}) => {
  const { t } = useLocalization();
  const subject = details.subjects[0];
  const cdnBase = (import.meta as ImportMeta & { env: { VITE_CDN_BASE?: string } })
    .env?.VITE_CDN_BASE;

  const iconSrc =
    subject?.subject_icon_url &&
    subject.subject_icon_url !== ICON_PLACEHOLDER &&
    !subject.subject_icon_url.startsWith("http")
      ? `${cdnBase ?? ""}${subject.subject_icon_url}`
    : subject?.subject_icon_url &&
        subject.subject_icon_url !== ICON_PLACEHOLDER &&
        subject.subject_icon_url.startsWith("http")
      ? subject.subject_icon_url
      : undefined;

  // Get translated labels - show key as fallback until translations are added
  const gradeLabel = subject?.grade_localization_code
    ? t(subject.grade_localization_code)
    : "";
  
  const termLabel = details.class_semester_localization_key
    ? t(details.class_semester_localization_key)
    : "";
  
  const typeLabel = details.class_type ?? "";

  const metaParts = [gradeLabel, termLabel, typeLabel].filter(Boolean);

  return (
    <header className="session-details-header">
      <div className="session-details-header__banner" aria-hidden />
      <div className="session-details-header__inner">
        <div className="session-details-header__icon-wrap">
          {iconSrc ? (
            <img
              src={iconSrc}
              alt=""
              className="session-details-header__icon"
            />
          ) : (
            <div className="session-details-header__icon session-details-header__icon--fallback" />
          )}
        </div>
        <h1 className="session-details-header__title">{details.class_title}</h1>
        {metaParts.length > 0 && (
          <p className="session-details-header__meta">
            {metaParts.join(
              ` ${t("session_details_meta_separator", "•")} `
            )}
          </p>
        )}
      </div>
    </header>
  );
};
